import useResources from "../../../hooks/UseResources";
import * as GrandPrixService from "../../../services/GrandPrixService";

export default function useGrandsPrix() {
    return useResources(GrandPrixService.getAllGrandsPrix, "data");
}
